import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { UserSession } from '../user-session.model';

@JsonObject('UserSessionsResultsResponse')
export class UserSessionsResultsResponse extends ApiResultsResponse<UserSession> {

  @JsonProperty('results', [UserSession])
  override results: UserSession[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
